import { createTheme, useTheme } from "@mui/material";
import { useMemo } from "react";

const useTableTheme = () => {
  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: globalTheme.palette.info.main,
          },
          background: {
            default: "#fff !important",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "0.8rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  return tableTheme;
};

export default useTableTheme;
